export default __webpack_public_path__ + "static/retail-video-shopper-4c737dc5239e935afd8f4373909d2517.gif";